var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"align":"center"}},[_c('br'),_c('h1',[_vm._v("Sua conta")]),_c('br'),_vm._v("\n  "+_vm._s(_vm.user.name)),_c('br'),_vm._v("\n  "+_vm._s(_vm.user.email)),_c('br'),_vm._v("\n  "+_vm._s(_vm.user.phone)),_c('br')])
}
var staticRenderFns = []

export { render, staticRenderFns }